import type { IconProps } from './icons.types';

export function ChevronBackIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 7 12" fill="currentColor" aria-hidden="true">
      <path d="M5.65375 11.3075L0 5.65375L5.65375 0L6.7075 1.05375L2.1075 5.65375L6.7075 10.2538L5.65375 11.3075Z" />
    </svg>
  );
}
